
import Vue from "vue";
import API from "@/api/API";
import store from "@/store";
import {
  requiredRule,
  minNumberRule,
  maxNumberRule,
} from "@/services/helpers/validation-rules";

export default Vue.extend({
  name: "Edit",

  data: () => ({
    model: {} as any,
    specialities: [] as Array<any>,
    disableSave: true as boolean,
    fullLoaded: false as boolean,
    errorMessages: {} as any,
  }),

  watch: {
    model: {
      deep: true,
      handler() {
        if (this.fullLoaded) {
          this.disableSave = false;
        }
      },
    },
  },

  computed: {
    computedRules(): object {
      return {
        minNum: minNumberRule.bind(this),
        maxNum: maxNumberRule.bind(this),
        required: requiredRule.bind(this),
      };
    },
  },

  async beforeRouteEnter(to, from, next) {
    try {
      const item = await API.budgetPlaces().getForEdit(Number(to.params.id));
      const specialities = await API.specialities().getList();

      next((vm) => {
        vm.model = item;
        vm.specialities = specialities;
        vm.$nextTick(() => {
          vm.fullLoaded = true;
        });
      });
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
  },

  methods: {
    getYearsInterval() {
      const allowedYears: number[] = [];
      for (
        let i = new Date().getFullYear();
        i <= new Date().getFullYear() + 5;
        i++
      ) {
        allowedYears.push(i);
      }
      return allowedYears;
    },
    async submit(): Promise<void> {
      try {
        if ((this.$refs.form as any).validate()) {
          await this.$API
            .budgetPlaces()
            .edit(this.$route.params.id as any, this.model);
          await this.$router.push("/budgetPlaces");
          await this.$store.dispatch(
            "alert/showSuccess",
            this.$t("global-alert.successful_edit")
          );
        }
      } catch (e) {
        if (e.hasOwnProperty("errors")) {
          this.errorMessages = e.errors;
          setTimeout(() => {
            this.errorMessages = {};
          }, 2000);
        }
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
  },
});
